module.exports = __webpack_public_path__ + "img/pro_mega10_03.835030ef.png";